import React, { useState } from 'react';
import { Row, Col, Button, Dropdown, Form } from 'react-bootstrap';
import './AdminProfessionalInfo.css';
import Swal from 'sweetalert2';

function AdminChillerTechnicianFields({ formData, setFormData }) {

    const [skillDropdownOpen, setSkillDropdownOpen] = useState(false);
    const [skillSearch, setSkillSearch] = useState('');

    const updateField = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    const toggleArrayField = (field, item, maxLimit = null) => {
        const currentArray = Array.isArray(formData[field]) ? formData[field] : [];
        if (currentArray.includes(item)) {
            updateField(field, currentArray.filter(i => i !== item));
        } else {
            if (maxLimit && currentArray.length >= maxLimit) {
                Swal.fire({ icon: 'warning', title: 'Limit Reached', text: `You can select a maximum of ${maxLimit} options.`, confirmButtonColor: '#0d6efd' });
                return;
            }
            updateField(field, [...currentArray, item]);
        }
    };

    const chillerTypeOptions = ["Air Cooled Chiller", "Water Cooled Chiller", "Screw Chiller", "Centrifugal Chiller", "Scroll Chiller", "Absorption Chiller"];
    const systemKnowledgeOptions = ["Cooling Towers", "Chilled Water Pumps", "Condenser Water Pumps", "AHU / FCU Integration", "BMS", "Heat Exchangers"];
    const technicalSkillsOptions = ["Installation", "Commissioning", "Preventive Maintenance", "Breakdown Troubleshooting", "Gas Charging", "Leak Detection", "Compressor Overhauling", "Tube Cleaning", "Electrical Panel Checking", "Reading HVAC Drawings", "PLC Basic Knowledge"];
    const refrigerantOptions = ["R22", "R134a", "R410A", "R407C", "Other"];
    const toolsKnowledgeOptions = ["Manifold Gauge", "Vacuum Pump", "Recovery Machine", "Leak Detector", "Multimeter", "Clamp Meter", "Tube Cleaning Machine"];

    const chillerType = Array.isArray(formData.chiller_type) ? formData.chiller_type : [];
    const systemKnowledge = Array.isArray(formData.chiller_system_knowledge) ? formData.chiller_system_knowledge : [];
    const techSkills = Array.isArray(formData.chiller_technical_skills) ? formData.chiller_technical_skills : [];
    const refrigerant = Array.isArray(formData.chiller_refrigerant_knowledge) ? formData.chiller_refrigerant_knowledge : [];
    const toolsKnowledge = Array.isArray(formData.chiller_tools_knowledge) ? formData.chiller_tools_knowledge : [];

    const filteredSkills = technicalSkillsOptions.filter(s => s.toLowerCase().includes(skillSearch.toLowerCase()));

    return (
        <>
            <div className="mb-5">
                <h4 className="mb-3 fw-semibold text-dark d-flex align-items-center fields-headingfont">Chiller Technician Type</h4>
                <Row className="g-3 mb-3">
                    {chillerTypeOptions.map((option, idx) => (
                        <Col xs={6} sm={6} md={4} key={idx}>
                            <Button variant="light" className={`language-btn jobtype-btn w-100 ${chillerType.includes(option) ? 'selected-button' : ''}`} onClick={() => toggleArrayField('chiller_type', option)}>{option}</Button>
                        </Col>
                    ))}
                </Row>
            </div>

            <div className="mb-5">
                <h4 className="mb-3 fw-semibold text-dark d-flex align-items-center fields-headingfont">System Knowledge</h4>
                <Row className="g-3 mb-3">
                    {systemKnowledgeOptions.map((option, idx) => (
                        <Col xs={6} sm={6} md={4} key={idx}>
                            <Button variant="light" className={`language-btn jobtype-btn w-100 ${systemKnowledge.includes(option) ? 'selected-button' : ''}`} onClick={() => toggleArrayField('chiller_system_knowledge', option)}>{option}</Button>
                        </Col>
                    ))}
                </Row>
            </div>

            <div className="mb-5">
                <h4 className="mb-3 fw-semibold text-dark d-flex align-items-center fields-headingfont">
                    Technical Skills <span className="ms-2 text-muted" style={{ fontSize: '14px', fontWeight: 'normal' }}>(Max 4 options)</span>
                </h4>
                <Dropdown show={skillDropdownOpen} onToggle={(open) => setSkillDropdownOpen(open)}>
                    <Dropdown.Toggle variant="light" className="language-select w-100 d-flex justify-content-between align-items-center" id="dropdown-admin-chiller-skills">
                        <span style={{ color: techSkills.length > 0 ? '#212529' : '#6c757d' }}>
                            {techSkills.length > 0 ? `Technical Skills (${techSkills.length} selected)` : 'Select Technical Skills'}
                        </span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="w-100" style={{ overflowY: 'hidden' }}>
                        <div className="px-2 py-1">
                            <Form.Control type="text" placeholder="Search skills..." value={skillSearch} onChange={(e) => setSkillSearch(e.target.value)} onClick={(e) => e.stopPropagation()} className="mb-2" autoFocus />
                        </div>
                        <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                            {filteredSkills.map((skill) => (
                                <Dropdown.Item key={skill} active={techSkills.includes(skill)} onClick={() => toggleArrayField('chiller_technical_skills', skill, 4)}>{skill}</Dropdown.Item>
                            ))}
                        </div>
                    </Dropdown.Menu>
                </Dropdown>
                {techSkills.length > 0 && (
                    <div className="mt-3 d-flex flex-wrap gap-2">
                        {techSkills.map((skill, idx) => (
                            <div key={idx} className="badge bg-primary d-flex align-items-center" style={{ fontSize: '0.85rem' }}>
                                {skill}
                                <button type="button" className="btn-close btn-close-white ms-2" style={{ fontSize: '0.5rem' }} onClick={() => toggleArrayField('chiller_technical_skills', skill)} aria-label="Remove" />
                            </div>
                        ))}
                    </div>
                )}
            </div>

            <div className="mb-5">
                <h4 className="mb-3 fw-semibold text-dark d-flex align-items-center fields-headingfont">Refrigerant Knowledge</h4>
                <Row className="g-3 mb-3">
                    {refrigerantOptions.map((option, idx) => (
                        <Col xs={6} sm={6} md={4} key={idx}>
                            <Button variant="light" className={`language-btn jobtype-btn w-100 ${refrigerant.includes(option) ? 'selected-button' : ''}`} onClick={() => toggleArrayField('chiller_refrigerant_knowledge', option)}>{option}</Button>
                        </Col>
                    ))}
                </Row>
            </div>

            <div className="mb-5">
                <h4 className="mb-3 fw-semibold text-dark d-flex align-items-center fields-headingfont">Tools & Equipment Knowledge</h4>
                <Row className="g-3 mb-4">
                    {toolsKnowledgeOptions.map((tool, idx) => (
                        <Col xs={6} sm={6} md={4} key={idx}>
                            <Button variant="light" className={`language-btn jobtype-btn w-100 ${toolsKnowledge.includes(tool) ? 'selected-button' : ''}`} onClick={() => toggleArrayField('chiller_tools_knowledge', tool)}>{tool}</Button>
                        </Col>
                    ))}
                </Row>
            </div>
        </>
    );
}

export default AdminChillerTechnicianFields;
